import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Mail, ArrowLeft } from 'lucide-react'
import AuthLayout from '@/components/AuthLayout'
import { api } from '@/lib/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async () => {
    if (!email.trim()) {
      setError('И-мэйл хаягаа оруулна уу')
      return
    }
    setError('')
    setLoading(true)
    try {
      await api.auth.forgotPassword(email.trim())
      navigate('/reset-password', { state: { email: email.trim() } })
    } catch (err: any) {
      setError(err.message || 'Алдаа гарлаа')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout>
      <div className="w-full max-w-[550px] flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-bold text-black">Нууц үг сэргээх</h1>
          <p className="text-sm text-gray-600">
            Бүртгэлтэй и-мэйл хаягаа оруулна уу. Бид танд нууц үг сэргээх код илгээх болно.
          </p>
        </div>

        {error && (
          <div className="bg-red-50 text-red-600 text-sm rounded-xl px-4 py-3">{error}</div>
        )}

        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-medium text-gray-700">И-мэйл хаяг</label>
          <div className="bg-white border border-gray-200 rounded-full px-3.5 py-2.5 shadow-xs flex items-center gap-2 focus-within:border-primary-500 focus-within:ring-1 focus-within:ring-primary-500 transition">
            <Mail className="size-[18px] text-gray-400 shrink-0" />
            <input
              type="email"
              placeholder="info@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              className="flex-1 outline-none text-base text-gray-900 placeholder:text-gray-300 bg-transparent"
            />
          </div>
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-primary-500 text-white rounded-full px-[18px] py-3 text-base font-semibold shadow-xs hover:bg-primary-600 transition disabled:opacity-50"
        >
          {loading ? 'Илгээж байна...' : 'Код илгээх'}
        </button>

        <Link
          to="/login"
          className="flex items-center justify-center gap-2 text-sm font-semibold text-gray-600 hover:text-gray-800"
        >
          <ArrowLeft className="size-5" />
          Нэвтрэх хуудас руу буцах
        </Link>
      </div>
    </AuthLayout>
  )
}
